import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Select, MenuItem } from '@material-ui/core';

const styles = theme => ({
  menuStyle: {
    'margin-right': '.5em',
    'margin-left': '.5em',
    minWidth: 55,
    '&&.Mui-disabled': {
      minWidth: 0
    },
    '&&.Mui-disabled:before': {
      borderBottom: 'none'
    }
  },
  disabled: {
    '&&': {
      color: theme.palette.text.primary,
      paddingRight: 0
    }
  }
});

var _ref = /*#__PURE__*/React.createElement("div", null);

const hideMenu = {
  key: 'hidden',
  open: false,
  IconComponent: () => _ref,
  onOpen: () => null
};
export class BareSitePicker extends React.PureComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "handleChange", event => {
      const el = event.target;
      this.setState({
        [el.name]: el.value
      });
      this.props.onSiteChange(el.value);
    });

    _defineProperty(this, "componentDidUpdate", prevProps => {
      const {
        id
      } = this.props.currentSite;

      if (prevProps.currentSite.id !== id) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          id
        });
      }
    });

    this.state = {
      id: this.props.currentSite.id,
      siteList: this.props.siteList && this.props.siteList.length ? this.props.siteList : [this.props.currentSite]
    };
  }

  static getDerivedStateFromProps(newProps, prevState) {
    if (prevState.siteList !== newProps.siteList) {
      return {
        id: newProps.currentSite.id,
        siteList: Array.isArray(newProps.siteList) && newProps.siteList.length ? newProps.siteList : [newProps.currentSite]
      };
    }

    return null;
  }

  render() {
    const {
      classes,
      disabled,
      selectProps
    } = this.props;
    const items = this.state.siteList.map(item => /*#__PURE__*/React.createElement(MenuItem, {
      key: item.id,
      value: item.id
    }, item.nickName));
    const toggleProps = this.state.siteList.length < 2 || disabled ? hideMenu : {
      key: 'show'
    };
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, _extends({
      value: this.state.id,
      disabled: disabled,
      onChange: this.handleChange,
      className: classes.menuStyle,
      classes: {
        disabled: classes.disabled
      },
      inputProps: {
        'data-testid': 'select-input',
        name: 'id',
        id: 'id'
      }
    }, selectProps, toggleProps), items));
  }

}

_defineProperty(BareSitePicker, "displayName", 'SitePicker');

_defineProperty(BareSitePicker, "defaultProps", {
  currentSite: {
    id: '',
    nickName: ''
  },
  siteList: [],
  onSiteChange: () => null
});

const SitePicker = withStyles(styles)(BareSitePicker);
SitePicker.displayName = 'SitePicker';
export default SitePicker;